import React, { Component } from 'react';

import Spinner from '../../base/features/micro/Spinner';
import { fixObject } from '../../base/utils/convert_to_object';
import Profile from '../../features/profile/Profile';
import { getShopUid } from '../../settings/domainManager';
import Header from './blocks/Header';
import ShopNavBottom from './blocks/ShopNavBottom';
import ShopOrders from './orders/ShopOrders';
import Products from './products/Products';
import { shopDetails } from './services';
import ShopComments from './shopComments/ShopComments';
import ShopHome from './shopHome/ShopHome';

class Shop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopProperties: null,
      shop_uid: getShopUid(),
      path:
        window.location.search && fixObject(window.location.search).tab
          ? fixObject(window.location.search).tab
          : "products",
    };
  }
  componentDidMount() {
    this.getShopProperties();
  }
  getShopProperties() {
    shopDetails(this.state.shop_uid, window.location.search).then((items) => {
      if (items) {
        this.setState({
          shopProperties: items,
          shop_uid: items.uid,
        });
        document.title = `${items.title}`;
        // document.title = `${items.title} | گیتی مارکت`;
        if (
          items.personalize &&
          items.personalize.products_visible === false &&
          this.state.path === "products"
        ) {
          this.setState({ path: "home" });
        }
        if (
          items?.personalize &&
          items?.personalize?.products_visible &&
          items?.personalize?.default_tab !== ""
        ) {
          this.setState({
            shopProperties: items,
            shop_uid: items.uid,
            path: items?.personalize?.default_tab,
          });
        }
      }
    });
  }
  componentDidUpdate(prv_props, prv_state) {
    // if (
    //   window.location.search &&
    //   fixObject(window.location.search).tab === "info" &&
    //   this.state.path !== "info"
    // ) {
    //   this.setState({ path: "info" });
    // }
    // if (
    //   window.location.search &&
    //   fixObject(window.location.search).tab === "products" &&
    //   this.state.path !== "products"
    // ) {
    //   this.setState({ path: "products" });
    // }
    // if (
    //   window.location.search &&
    //   fixObject(window.location.search).tab === "comments" &&
    //   this.state.path !== "comments"
    // ) {
    //   this.setState({ path: "comments" });
    // }
    // if (
    //   window.location.search &&
    //   fixObject(window.location.search).tab === "orders" &&
    //   this.state.path !== "orders"
    // ) {
    //   this.setState({ path: "orders" });
    // }
    // if (this.state.shop_uid !== getShopUid()) {
    //   this.setState(
    //     {
    //       shop_uid: getShopUid(),
    //       shopProperties: null,
    //     },
    //     () => this.getShopProperties()
    //   );
    // }
  }

  render() {
    return (
      <div
        className="container-fluid px-0"
        dir="rtl"
        key={this.state.shopProperties && this.state.shopProperties.uid}
      >
        <Header
          shopProperties={this.state.shopProperties}
          refresh={(shopUid) => {
            this.setState({ shop_uid: shopUid, shopProperties: null }, () =>
              this.getShopProperties()
            );
          }}
        />
        {this.state.shopProperties ? (
          <div style={{ marginBottom: "80px", marginTop: "60px" }}>
            {this.state.path === "home" && (
              <ShopHome shopProperties={this.state.shopProperties} />
            )}
            {this.state.path === "comments" && <ShopComments />}
            {this.state.path === "orders" && <ShopOrders />}
            {this.state.path === "profile" && <Profile />}
            {this.state.path === "products" && (
              <Products
                config={
                  this.state.shopProperties && this.state.shopProperties.config
                }
                product_categories={
                  this.state.shopProperties &&
                  this.state.shopProperties.product_categories
                }
                shopProperties={this.state.shopProperties}
              />
            )}
          </div>
        ) : (
          <div className="mt-5">
            <Spinner />
          </div>
        )}
        {this.state.shopProperties &&
          this?.state?.shopProperties?.personalize
            ?.button_navigation_visible && (
            <ShopNavBottom
              path={this.state.path}
              personalize={this.state.shopProperties.personalize}
              changePath={(pathName) => this.setState({ path: pathName })}
            />
          )}
      </div>
    );
  }
}

export default Shop;
